/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivBufferGen,
  MrfiktivFleetReportControllerGetAllParamsGen,
  MrfiktivFleetReportControllerGetAllPostParamsGen,
  MrfiktivFleetReportControllerGetDamageReportPdfParamsGen,
  MrfiktivMultipleIdsDtoOptionalGen,
  MrfiktivPageViewModelGen,
  MrfiktivReportViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FleetReport<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Report
   * @name FleetReportControllerGetAll
   * @summary (FLEET-REPORT-READ) Get all reports
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/report
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivReportViewModelGen)[] })`
   */
  fleetReportControllerGetAll = (
    { partnerId, fleetId, ...query }: MrfiktivFleetReportControllerGetAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivReportViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/report`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Report
   * @name FleetReportControllerGetAllPost
   * @summary (FLEET-REPORT-READ) Get all reports
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/report
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivReportViewModelGen)[] })`
   */
  fleetReportControllerGetAllPost = (
    { partnerId, fleetId, ...query }: MrfiktivFleetReportControllerGetAllPostParamsGen,
    data: MrfiktivMultipleIdsDtoOptionalGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivReportViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/report`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Report
   * @name FleetReportControllerGetOne
   * @summary (FLEET-REPORT-READ) Get a report by reportId
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/report/{reportId}
   * @secure
   * @response `201` `MrfiktivReportViewModelGen` Get a report by reportId
   */
  fleetReportControllerGetOne = (partnerId: string, fleetId: string, reportId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivReportViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/report/${reportId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Report
   * @name FleetReportControllerGetDamageReportPdf
   * @summary (FLEET-REPORT-READ) Generate a damage report PDF (Schadenbericht)
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/report/{reportId}/pdf
   * @secure
   * @response `200` `MrfiktivBufferGen` Damage report PDF with 3-column layout
   */
  fleetReportControllerGetDamageReportPdf = (
    { partnerId, reportId, fleetId, ...query }: MrfiktivFleetReportControllerGetDamageReportPdfParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBufferGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/report/${reportId}/pdf`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
